export default "<rmd:protectedcontent>\n\t<div data-id='visibleContent'></div>\n</rmd:protectedcontent>";